import { defineMessages } from 'react-intl';

export const complimentaryTrialEndedModalMessages = defineMessages({
  title: {
    defaultMessage: 'Your complimentary Max usage has ended',
    id: 'HJoDFTovFx',
    description:
      'Title of the modal shown once a member’s complimentary Max usage period ends',
  },
  bodyModerate: {
    defaultMessage:
      'Your agentic use fit within {currentPlanName} limits. To ensure you’ll always have room, upgrade to {targetPlanName}.',
    id: 'dCF5S8dgnu',
    description:
      'Body of the complimentary Max usage ended modal for a member who used a moderate share of their plan allowance. currentPlanName is their plan, targetPlanName the recommended upgrade',
  },
  bodyHigh: {
    defaultMessage:
      'You got a lot done with Heidi’s agentic features. {currentPlanName} has lower limits, so upgrade to keep using them.',
    id: 'ykiT+wvX5e',
    description:
      'Body of the complimentary Max usage ended modal for a member who went past their plan allowance. currentPlanName is their plan',
  },
  upgrade: {
    defaultMessage: 'Upgrade to {targetPlanName}',
    id: 'JmUR+2sSXu',
    description:
      'Primary button in the complimentary Max usage ended modal. targetPlanName is the recommended plan',
  },
  stay: {
    defaultMessage: 'Stay on {currentPlanName}',
    id: 'X4/cH6/Lcd',
    description:
      'Secondary button in the complimentary Max usage ended modal that keeps the member on their current plan',
  },
  footnote: {
    defaultMessage:
      'Your price and billing stay the same on {currentPlanName}. Usage limits apply.',
    id: 'OBuM8DUU95',
    description:
      'Footnote under the buttons in the complimentary Max usage ended modal explaining what staying on the current plan means',
  },
});
